import { createApi } from '@reduxjs/toolkit/query/react';
import { urls } from '../../utils/helpers/ApiClient';
import axiosFetchBase from '../axiosFetchBase';

export const erasmusMobilitiesApi = createApi({
  reducerPath: 'erasmusMobilitiesApi',
  keepUnusedDataFor: 0,
  baseQuery: axiosFetchBase,
  endpoints: (builder) => ({
    getErasmusMobilities: builder.query({
      query: (user) => {
        return {
          url: urls.erasmusMobilities,
          params: { user },
        };
      },
    }),
    getErasmusMobility: builder.query({
      query: (id) => ({
        url: urls.erasmusMobilityDetail(id),
      }),
    }),
    saveErasmusMobility: builder.mutation({
      query(req) {
        const data = {
          ...req.body,
          active: req.body.active ? '1' : '0',
        };

        if (req.body.application && typeof req.body.application === 'object') {
          data.application = JSON.stringify(req.body.application);
        }

        //  Universal file detection - cheks all body properties
        const fileEntries = Object.entries(req.body).filter(
          ([_, value]) => value instanceof File,
        );
        const hasFile = fileEntries.length > 0;
        const [fileFieldName, fileValue] = hasFile
          ? fileEntries[0]
          : [null, null];

        ///Only create FormData if we have a file
        const requestData = hasFile ? new FormData() : data;

        if (hasFile) {
          // Append all data to FormData
          Object.keys(data).forEach((key) => {
            const value = data[key];
            if (value !== undefined && value !== null) {
              if (value instanceof File) {
                requestData.append(key, value, value.name);
              } else {
                requestData.append(key, value);
              }
            }
          });
        }

        if (req.id) {
          if (hasFile) {
            requestData.append('_method', 'PUT');
          }
          return {
            url: urls.erasmusMobilityDetail(req.id),
            method: hasFile ? 'POST' : 'PUT', // Use POST with _method forfile uploads
            data: requestData,
          };
        } else {
          return {
            url: urls.erasmusMobilities,
            method: 'POST',
            data: requestData,
          };
        }
      },
    }),
    deleteErasmusMobility: builder.mutation({
      query(id) {
        return {
          url: urls.erasmusMobilityDetail(id),
          method: 'DELETE',
        };
      },
    }),
    getErasmusMobilityPrivateFile: builder.query({
      query: (params) => {
        const { id, filename } = params || {};
        return {
          url: urls.erasmusMobilityPrivateFileDownload(id, filename),
          method: 'GET',
        };
      },
    }),
  }),
});

export const {
  useGetErasmusMobilitiesQuery,
  useGetErasmusMobilityQuery,
  useSaveErasmusMobilityMutation,
  useDeleteErasmusMobilityMutation,
  useGetErasmusMobilityPrivateFileQuery,
  useLazyGetErasmusMobilityPrivateFileQuery,
} = erasmusMobilitiesApi;
